import React from 'react';

import SplashIllustration from './SplashIllustration';

function SplashNarrative() {
  return (
    <div className="splash-narrative">
      <div className="row">
        <h2 className="splash-narrative__heading">
          What’s at Stake
        </h2>
        <div className="text splash-narrative__text">
          <p>
            <strong>Errors associated with injectable medications are more likely to result in death and morbidity than medications given through other routes of administration.</strong>
          </p>
          <p>
            Because the risk of error exists not only in administration, but also in preparation and manipulation of medications, The Joint Commission Medication Management standards direct that medications be dispensed in the most ready-to-administer (RTA) form as possible.
          </p>
          <p>
            Even with that goal in mind, the reality is that there are often barriers.
          </p>
          <p>
            This tool has been designed to identify those barriers in order to tailor performance improvement efforts and achieve the goal of dispensing medications in the most ready-to-administer (RTA) form possible.
          </p>
        </div>
        <div className="text splash-narrative__illustration">
          <SplashIllustration />
        </div>
      </div>
    </div>
  );
}

export default SplashNarrative;



// WEBPACK FOOTER //
// ./src/components/features/splash/SplashNarrative.js